var navscrollElement = document.querySelector('.it-navscroll-wrapper')
var config = {
	scrollPadding:125
}
if(navscrollElement) {
	var navscroll = new bootstrap.NavScroll(navscrollElement, config)
}
